<template>
  <md-table-cell :class="isLastSelected ? isLastSelected(item) : ''" :id="item.meterId">
    <div class="md-layout md-gutter md-size-100 cell-alignment"
         :id="item.serialNo"
         :style="item.isEdited ? 'background: red' : ''">
      <div class="md-layout-item md-size-30">
        <label>{{ $t('captureMR.Statuses')}}</label>
      </div>
      <div class="md-layout-item md-size-70">
        <div class="fa fa-pencil-square-o margin-right-3"
             v-if="item.status != 3 && item.readingDiscrepancyType == 2"
             style="font-size: x-large; margin-top: 5px;"
             :style="isDisconnectedDiscrepancyColor(item)"></div>

        <md-icon class="margin-right-3"
                 v-if="item.status != 3 && (item.readingDiscrepancyType == 0 || (item.readingDiscrepancyType >=3 && item.readingDiscrepancyType <= 17))"
                 :style="isDisconnectedDiscrepancyColor(item)">check_circle</md-icon>

        <md-icon class="margin-right-3"
                 v-if="item.status != 3 && item.readingDiscrepancyType == 1"
                 :style="isDisconnectedDiscrepancyColor(item)">vpn_key_off</md-icon>

        <md-icon class="margin-right-3"
                 v-if="item.status == 3"
                 :style="isDisconnectedDiscrepancyColor(item)">block</md-icon>
      </div>

      <div class="md-layout-item md-size-30">
        <label>{{ $t('meter.meterNo')}}</label>
      </div>
      <div class="md-layout-item md-size-70">
        <label class="display-important-info">{{ item.serialNo }}</label>
      </div>

      <div class="md-layout-item md-size-30">
        <label>{{ $t('captureMR.propertyReference')}}</label>
      </div>
      <div class="md-layout-item md-size-70">
        <label>{{ item.propRef }}</label>
      </div>

      <div class="md-layout-item md-size-30">
        <label>{{ $t('captureMR.propertyAddress')}}</label>
      </div>
      <div class="md-layout-item md-size-70">
        <label class="display-important-info">{{ item.propertyAddress }}</label>
      </div>

      <div class="md-layout-item md-size-30">
        <label>{{ $t('captureMR.tenantName')}}</label>
      </div>
      <div class="md-layout-item md-size-70">
        <label>{{ item.tenantName }}</label>
      </div>

      <div class="md-layout-item md-size-30">
        <label>{{ $t('captureMR.ColumnConsumerType')}}</label>
      </div>
      <div class="md-layout-item md-size-70">
        <label>{{ item.consumerType }}</label>
      </div>

      <div v-if="isPropertyOriented!=true"
           class="md-layout-item md-size-30">
        <label>{{ $t('captureMR.ColumnCustomerNo')}}</label>
      </div>

      <div v-if="isPropertyOriented!=true"
           class="md-layout-item md-size-70">
        <label>{{ item.account }}</label>
      </div>
    </div>
  </md-table-cell>
</template>

<script>
  export default {
    name: 'readingsListCell',
    props: {
      item: {
        type: Object,
        required: true
      },
      isPropertyOriented: {
        type: Boolean,
        default: false,
      },
      isLastSelected: {
        type: Function,
        default: null,
      }
    },
    data: function () {
      return {}
    },
    mounted() {
     
    },
  
    methods: {    
      isDisconnectedDiscrepancyColor(item) {
        if (item.connectionStatus == 2 || item.connectionStatus == 3)
          return 'color: red!important;'
        else if (item.readingDiscrepancyType >= 3 && item.readingDiscrepancyType <= 17)
          return 'color: #FF8C00!important;'
        else
          return '';
      },    
    }
  }
</script>
<style>
  .margin-right-3 {
    font-size: x-large;
    margin-right: 3px;
  }

  .display-important-info {
    font-weight: bold;
    color: var(--blue_text);
  }
</style>
